import { Link } from 'react-router-dom';
import { useCurrency } from '@/contexts/CurrencyContext';

export default function ProductCard({ product, formatPrice }) {
  const img = product.images?.[0]?.url;
  const img2 = product.images?.[1]?.url;
  const hasSale = product.compare_at_price > product.price;
  const savePct = hasSale ? Math.round((1 - product.price / product.compare_at_price) * 100) : 0;

  return (
    <div data-testid={`product-card-${product.handle}`} className="group flex flex-col">
      <Link to={`/product/${product.handle}`} className="relative aspect-square overflow-hidden block mb-3" style={{ backgroundColor: '#f5f3ef' }}>
        {img ? (
          <>
            <img src={img} alt={product.title} loading="lazy"
              className="object-cover w-full h-full transition-all duration-500 group-hover:opacity-0" />
            {img2 && (
              <img src={img2} alt={product.title} loading="lazy"
                className="absolute inset-0 object-cover w-full h-full opacity-0 transition-all duration-500 group-hover:opacity-100 group-hover:scale-103" />
            )}
            {!img2 && (
              <div className="absolute inset-0 w-full h-full transition-transform duration-500 group-hover:scale-[1.03]">
                <img src={img} alt={product.title} className="object-cover w-full h-full" />
              </div>
            )}
          </>
        ) : (
          <div className="w-full h-full flex items-center justify-center font-sans text-xs" style={{ color: 'rgba(0,0,0,0.25)' }}>No Image</div>
        )}
        {hasSale && (
          <span className="absolute top-3 left-3 px-2.5 py-1 font-sans text-[11px] font-semibold"
            style={{ backgroundColor: '#000', color: '#fff' }}>
            Save {savePct}%
          </span>
        )}
      </Link>

      <Link to={`/product/${product.handle}`} className="flex-1">
        <h3 className="font-sans text-sm leading-snug mb-1.5 line-clamp-2" style={{ color: '#333' }}>
          {product.title}
        </h3>
        <div className="flex items-baseline gap-2">
          <span className="font-sans text-sm font-bold" style={{ color: '#000' }}>
            {formatPrice(product.price)}
          </span>
          {hasSale && (
            <span className="font-sans text-sm line-through" style={{ color: '#999' }}>
              {formatPrice(product.compare_at_price)}
            </span>
          )}
        </div>
      </Link>
    </div>
  );
}
